import * as generalActions from './generalActions';
import * as violationActions from './violationActions';

export const ActionCreators = {
  ...generalActions,
  ...violationActions,
};